// API Configuration
export const API_URL = process.env.REACT_APP_API_URL || 'https://careerfoundation.org.in/mobile_api/api';
export const BASE_URL = process.env.REACT_APP_BASE_URL || 'https://careerfoundation.org.in';
export const IMG_URL = process.env.REACT_APP_IMG_URL || 'https://careerfoundation.org.in/uploads/images/';
export const TEACHER_IMG = process.env.REACT_APP_TEACHER_IMG || 'https://careerfoundation.org.in/uploads/';
export const CHAT_URL = process.env.REACT_APP_CHAT_URL || 'https://careerfoundation.org.in/LiveChat/';
export const RAZORPAY_KEY = process.env.REACT_APP_RAZORPAY_KEY || 'rzp_live_QkaMpUNBYhZzQU';

// App Configuration
export const APP_NAME = 'Career Foundation';
export const APP_DESCRIPTION = 'Best Coaching Center for Jharkhand Govt. Exams Preparation';

// Payment Configuration (matching mobile app)
export const GST_CHARGE = 18;
export const NET_HANDELING = 5;

// Routes
export const ROUTES = {
  HOME: '/',
  LOGIN: '/login',
  REGISTER: '/register',
  FORGOT_PASSWORD: '/forgot-password',
  OTP_LOGIN: '/otp-login',
  COURSE_LIST: '/courses',
  COURSE_DETAILS: '/course/:courseId',
  MY_PURCHASED: '/my-purchased',
  PROFILE: '/profile',
  EDIT_PROFILE: '/edit-profile',
  CHANGE_PASSWORD: '/change-password',
  COURSE_VIDEOS: '/course-videos/:courseId/:subjectId',
  SUBJECTS: '/course/:courseId/subjects',
  CONTACT: '/contact-us',
  ABOUT: '/about-us',
  TEST_SERIES: '/test-series',
  BLOG: '/blog',
  DEMO_VIDEOS: '/demo-videos',
};

// Local Storage Keys
export const STORAGE_KEYS = {
  USER_INFO: 'userInfo',
  AUTH_TOKEN: 'authToken',
  DEVICE_ID: 'deviceId',
  FCM_TOKEN: 'fcmToken',
};

